module.exports = __webpack_public_path__ + "assets/img/service5.2919822b.png";